<template>
  <div>
    <div class="mb-2 flex justify-end">
      <ExportMenu :disabled="!rowData.length" :exports="[{ type: 'excel', action: exportToExcel }]" />
    </div>
    <div :class="[!autoHeight ? 'h-96':'']" >
      <AgGridVue
        :theme="standardListTheme"
        style="width: 100%; height: 100%"
        :column-defs="computedColumnDefs"
        :row-data="rowData"
        :default-col-def="defaultColDef"
        :auto-group-column-def="autoGroupColumnDef"
        :group-display-type="groupDisplayType"
        :grid-options="gridOptions"
        :loading="loading"
        @grid-ready="onGridReady"
      />
    </div>
  </div>

</template>

<script>
import axios from 'axios';
import { AgGridVue } from 'ag-grid-vue3';
import CC_Router_Link_To_Object from '@/components/widgetcomponents/AG_Grid_Custom_Cells/CC_Router_Link_To_Object.vue';
import ConfirmationModal from '@/components/widgetcomponents/ConfirmationModal.vue';
import {standardListTheme} from '@/utils/common';
import ExportMenu from '@/components/widgetcomponents/library/ExportMenu.vue';

export default {
  components: {
    ConfirmationModal,
    AgGridVue,
    CC_Router_Link_To_Object,
    ExportMenu,
  },
  props: {
    enableDrag:{
      type: Boolean,
      default:false
    },
    autoHeight:{
      type:Boolean,
      required:false,
      default:false
    },
    filters: {
      type: Object,
      required: false,
    },
    grouperColumns: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      gridApi:null,
      gridOptions: {
        suppressAggFuncInHeader: true,
        domLayout:this.autoHeight ? 'autoHeight':null,
      },
      loading: true,
      groupDisplayType: 'singleColumn',
      defaultColDef: {
        flex: 1,
        sortable: true,
        filter: true,
        resizable: true,
        wrapText: true,
        autoHeight:true,
        cellClass:'cell-theme-left-aligned'
      },
      autoGroupColumnDef: {
        headerName: 'Business Unit',
        cellRendererParams: {
          suppressCount: false,
        },
      },
      rowData: [],
    };
  },
  computed: {
    standardListTheme() {
      return standardListTheme
    },
    computedColumnDefs() {
      return [
        // Hidden aggregation columns
        {
          field:'performance_blocker_subcategory',
          headerName:'Performance Blocker Subcategory',
          rowGroup:true,
          hide:true,
        },
        {
          field:'entity_name',
          headerName:'Related Object Name',
          cellClass: 'sensitive',
          rowGroup:true,
          hide:true
        },
        {
          field:'performance_blocker_description',
          headerName:'Num Times Performance Blocker Cited',
          aggFunc: 'count',
        },
      ]
    },
  },
  methods: {
    async onGridReady(params) {
      this.gridOptions.api = params.api;
      this.gridOptions.columnApi = params.columnApi;

      try {

        // Use the new performanceblockers endpoint
        const response = await axios.get('/api/performanceblockers/table-data/', {
          params: this.filters
        });

        if (response.data?.rowData?.length > 0) {
          this.rowData = response.data.rowData;
          this.loading = false;
        } else {
          this.rowData = [];
          this.loading = false;
        }

        params.api.sizeColumnsToFit();
        window.addEventListener('resize', this.onWindowResize);
      } catch (error) {
        console.error('Error fetching performance blocker data:', error);
        this.rowData = [];
        this.loading = false;
      }
    },
    onWindowResize() {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    },
    exportToExcel() {
      const allColumns = this.gridOptions.api.getColumnDefs()
      const exportColumns = allColumns
        .filter(col => col.field !== 'autoGroupColumn')
        .map(col => col.field)
      if (this.gridOptions.api) {
        if (this.$root?.isDemoMode) return; // Demo Mode: block raw-data export
        this.gridOptions.api.exportDataAsExcel({
          allColumns: true,
          columnKeys:exportColumns
        });
      }
    },
  },
  mounted() {
    console.log(this.sqlFilters)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }
};
</script>

<style>
.header-center .ag-header-cell-label {
  text-align: center;
  justify-content: center;
}
.hover-over {
  background-color: #f0f8ff !important; /* Light gray background */
}
</style>
